export default "__VITE_ASSET__CpAh85PN__"